module.exports = __webpack_public_path__ + "staticcomp/img/article_bottom_logo.17ebef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/article_bottom_logo.png
// module id = KBSo
// module chunks = 39